import React, { MouseEvent, MouseEventHandler } from 'react';
import NextLink from 'next/link';
import { Button, Text, forwardRef } from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';

type Department = {
  id: number;
  name: string;
};

type DepartmentBadgeButtonProps = {
  department: Department;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  href?: string;
};

function DepartmentBadge({ department }: { department: Department }) {
  return (
    <Text
      px={2}
      py={{ base: 0.5, md: 1 }}
      fontSize="sm"
      fontWeight="bold"
      bg="white"
      color="brand.500"
      border="1px"
      borderRadius="full"
    >
      {department.name}
    </Text>
  );
}

const DepartmentBadgeButton = forwardRef<DepartmentBadgeButtonProps, 'a'>(
  ({ department, onClick, href }, ref) => {
    function onClickDepartmentBadgeLink(e: MouseEvent<HTMLButtonElement>) {
      sendAnalyticsEvent('slide', 'index', 'frequently_used_department');
      onClick?.(e);
    }

    return (
      <Button
        as="a"
        display="inline-block"
        color="inherit"
        _hover={{
          textDecoration: 'none',
        }}
        href={href}
        variant="link"
        onClick={onClickDepartmentBadgeLink}
      >
        <DepartmentBadge department={department} />
      </Button>
    );
  },
);

export default function DepartmentBadgeLink({
  department,
}: {
  department: Department;
}) {
  const href = `/department/${department.id}`;

  return (
    <NextLink href={href} passHref>
      <DepartmentBadgeButton department={department} href={href} />
    </NextLink>
  );
}
